import * as React from "react";
import { connect } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { ApiError } from "../../model/ApiError.model";
import { MeetingNoteDetail } from "../../model/MeetingNoteDetail.model";
import {MeetingNoteSummary} from "../../model/MeetingNoteSummary.model";
import { ErrorComponent } from "../base/Error.component";
import MeetingNoteComponent from "./MeetingNote.component";
import meetingNoteActions from "./meetingNoteActions";
import { IApplicationRootState } from "../../../applicationState";
import {useParams} from "react-router";
import {MeetingNotesApi} from "../../api/MeetingNotesApi";
import {useState} from "react";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {injectIntl, IntlShape} from "react-intl";

export interface IMeetingNotePageAction {
    getMeetingNoteDetailForProduct: typeof meetingNoteActions.getMeetingNoteDetailForProduct;
}

export interface IMeetingNotePagePropsFromActions {
    actions: IMeetingNotePageAction;
}

export interface IMeetingNotePagePropsFromStore {
    meetingNoteDetail: MeetingNoteDetail | null;
    error?: ApiError;
}

export interface IMeetingNoteIntlProps {
    intl: IntlShape;
}

export type MeetingNotePageProps = IMeetingNotePagePropsFromStore
    & IMeetingNotePagePropsFromActions & IMeetingNoteIntlProps;

export const MeetingNotePage: React.FunctionComponent<MeetingNotePageProps> = (props) => {
    const { productIdParam } = useParams();
    const productId = productIdParam ? parseInt(productIdParam!, 10) : undefined;
    const [meetingNoteSummary, setMeetingNoteSummary] = useState<MeetingNoteSummary | undefined>(undefined);
    const [error, setError] = useState<boolean>(false);

    React.useEffect(() => {
        if (productIdParam) {
            const productId = parseInt(productIdParam!, 10);
            MeetingNotesApi.requestLatestMeetingNoteForProduct(productId)
                .then ((response) => {
                    setMeetingNoteSummary(response);
                    if (response?.backstopId && response?.isExternal) {
                        props.actions.getMeetingNoteDetailForProduct(productId!, response?.backstopId);
                    } else {
                        setError(true);
                    }
                })
                .catch(() => {
                    setError(true);
                });
        }
    }, []);

    return error || props.error
        ? <ErrorComponent/>
        : meetingNoteSummary && props.meetingNoteDetail
            ? <div className="wealth-parent main-content" data-testid="meeting-note-page">
                    <MeetingNoteComponent
                        meetingNoteSummary={meetingNoteSummary}
                        meetingNoteDetail={props.meetingNoteDetail}
                        productId={productId}
                    />
                </div>
            : <LoadingSpinner/>;
};

export const mapStateToProps = (state: IApplicationRootState): any => {
    return {
        ...state.meetingNoteRootState,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IMeetingNotePagePropsFromActions => {
    return {
        actions: bindActionCreators(meetingNoteActions, dispatch),
    };
};

const connectedComponent = connect<IMeetingNotePagePropsFromStore, IMeetingNotePagePropsFromActions>(
    mapStateToProps,
    mapDispatchToProps,
)(MeetingNotePage);

export default injectIntl(connectedComponent);